// extracted by mini-css-extract-plugin
export var ball1 = "h_Z";
export var ball2 = "h_0";
export var bounce = "h_Y";
export var fullscreen = "h_W";
export var spinner = "h_X";